export const SET_MINISTRIES = 'SET_MINISTRIES';
export const SET_MINISTRY = 'SET_MINISTRY';
export const ADD_MINISTRY = 'ADD_MINISTRY';
export const UPDATE_MINISTRY = 'UPDATE_MINISTRY';
export const REMOVE_MINISTRY = 'REMOVE_MINISTRY';
export const CLEAR_MINISTRY = 'CLEAR_MINISTRY';
export const CLEAR_MINISTRIES = 'CLEAR_MINISTRIES';
